import { createActions, createReducer } from 'reduxsauce';
import dados from 'Dados/Regioes.json';
import municipios from 'Dados/ListaMunicipios.json';

export const { Types, Creators } = createActions({
	buscListaEndPrazoEnt: [ 'payload' ],
	buscListaEndPrazoEntSuces: [ 'payload' ],
	buscListaEntSuces: [ 'payload' ],
	setLoadPrazoEntre: [ 'payload' ],
	buscaMunicipios: [ 'payload' ],
	setListaExibirPrazoEntre: [ 'payload' ],
	setListaPrazoEntre: [ 'payload' ],
	buscaMunicipiosSucesso: [ 'payload' ],
	atualizaPrazoMuni: [ 'payload' ],
	exibirCardSelec: [ 'payload' ],
	listaAtuaPrazoEntr: [ 'payload' ],
	atualizaPrazoMuniSucesso: [ 'payload' ],
	setListaPrazoAlterado: [ 'payload' ],
	atualizarListaBack: [ 'payload' ]
});

const INIT_STATE = {
	filtros: {},
	loadPrazoEntre: false,
	listaDinamica: [],
	listaMuniIbge: [],
	cardExibirSelec: false,
	setRemSelecionados: [],
	listaMuniBack: municipios,
	listaAtualPrazo: [],
	listaEnt: dados,
	listaExibir: {
		filhos: [],
		niveis: []
	},
	lista: {}
};

const buscListaEndPrazoEntSuces = (state = INIT_STATE, action) => ({
	...state,
	listaDinamica: action.payload
});

const buscListaEntSuces = (state = INIT_STATE, action) => ({
	...state,
	listaEnt: action.payload
});

const setLoadPrazoEntre = (state = INIT_STATE, action) => ({
	...state,
	loadPrazoEntre: action.payload
});

const setListaExibirPrazoEntre = (state = INIT_STATE, action) => ({
	...state,
	listaExibir: action.payload
});

const exibirCardSelec = (state = INIT_STATE, action) => ({
	...state,
	cardExibirSelec: action.payload
});

const setListaPrazoEntre = (state = INIT_STATE, action) => {
	const lista = action.payload;
	return {
		...state,
		lista
	};
};

const buscaMunicipiosSucesso = (state = INIT_STATE, action) => {
	let { listaIbge, listaBack } = action.payload;
	return {
		...state,
		listaMuniIbge: listaIbge,
		listaMuniBack: listaBack
	};
};

const atualizarListaBack = (state = INIT_STATE, action) => {
	let { novaListaBack } = action.payload;
	return {
		...state,
		listaMuniBack: { ...state.listaMuniBack, ...novaListaBack }
	};
};

const listaAtuaPrazoEntr = (state = INIT_STATE, action) => ({
	...state,
	listaAtualPrazo: action.payload
});
const setListaPrazoAlterado = (state = INIT_STATE, action) => ({
	...state,
	listaAtualPrazo: action.payload
});
const atualizaPrazoMuniSucesso = (state = INIT_STATE, action) => {
	let lista = action.payload;
	return {
		...state,
		lista
	};
};

export default createReducer(INIT_STATE, {
	[Types.BUSC_LISTA_END_PRAZO_ENT_SUCES]: buscListaEndPrazoEntSuces,
	[Types.SET_LOAD_PRAZO_ENTRE]: setLoadPrazoEntre,
	[Types.BUSCA_MUNICIPIOS_SUCESSO]: buscaMunicipiosSucesso,
	[Types.SET_LISTA_EXIBIR_PRAZO_ENTRE]: setListaExibirPrazoEntre,
	[Types.SET_LISTA_PRAZO_ENTRE]: setListaPrazoEntre,
	[Types.BUSC_LISTA_ENT_SUCES]: buscListaEntSuces,
	[Types.EXIBIR_CARD_SELEC]: exibirCardSelec,
	[Types.LISTA_ATUA_PRAZO_ENTR]: listaAtuaPrazoEntr,
	[Types.ATUALIZA_PRAZO_MUNI_SUCESSO]: atualizaPrazoMuniSucesso,
	[Types.SET_LISTA_PRAZO_ALTERADO]: setListaPrazoAlterado,
	[Types.ATUALIZAR_LISTA_BACK]: atualizarListaBack
});
